export const MISL_BRANDS = {
    'an-us': '04',
    'an-uk': '54',
    'fp-us': '08',
    'uo-us': '01',
    'uo-uk': '51'
};

export const GET_MISL_STORE = 'GET_MISL_STORE';
